<div class="pre-verification-container">
  <div class="btn colored blue login-dropdown-btn go-btn" (click)="handleCloseAccountMenu()">
    <div class="change-password-text">{{ 'goToVerificationPage' | t }}</div>
  </div>
</div>
